

<div class="contain" [hidden]="isSpinnerHide" >
    <div class="main">
        <div class="container ">
            <div class="ring"></div>
            <div class="ring"></div>
            <div class="ring"></div>
            <b class="loading">{{screen}}</b>
        </div>
        <span style="position: relative;top: 9rem;font-size: 20px;
        font-weight: bold;color:rgb(255, 255, 255)"  > {{meassage}}</span>
    </div>
</div>